import { GraphicElement } from '@/types/GraphicElement';
import * as fabric from 'fabric';

export const useCanvasStore = defineStore('canvas', {
    state: () => ({
        selectedElement: null as null | GraphicElement,
        isCanvasTextureMounted: false as boolean,
        canvas: null as fabric.Canvas | null
    }),
    actions: {
        setCanvas(canvas: fabric.Canvas) {
            this.canvas = canvas;
        },
        getCanvas() {
            return this.canvas;
        }
    }
});
